// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'lib-flexible/flexible.js'
import '../static/reset.css'
import {getRequest, postRequest,postRequestN9,uploadFileRequestN9, deleteRequest, putRequest,uploadFileRequest} from './api/http'
import infiniteScroll from 'vue-infinite-scroll'
// 轮播，滑动组件
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)
//日期插件
import dateTime from 'vue-date-time-m';
Vue.use(dateTime, {
  name: 'data-time',
  props: {
    // dateTime 显示 年月日时分 默认值,
    // date     显示 年月日
    // time     显示 时分
    // year     显示 年
    // month    显示 月
    type: 'date',
    // 希望得到的格式
    // 默认的颜色 #50c7a7
    color: '#00acc1',
    // 是否显示现在按钮 默认是true
    showTodayButton: false,
    // 默认值left, 可以选left\center\right
    textAlign: 'left',
    // 时间间隔 1\2\3\4\5\6\10\12\15\20\30\60
    minutesInterval: 1
  }
});
// Vue.component('data-time', dateTime);
// 图片放大缩小各种操作
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer,{
  defaultOptions: {
    zIndex: 9999,
    "toolbar": false,
    "button": false,
  }
})
import lrz from 'lrz'
Vue.prototype.lrz = lrz
Vue.use(infiniteScroll)
Vue.config.productionTip = false
Vue.prototype.getRequest = getRequest
Vue.prototype.postRequest = postRequest
Vue.prototype.postRequestN9 = postRequestN9
Vue.prototype.uploadFileRequestN9 = uploadFileRequestN9
Vue.prototype.deleteRequest = deleteRequest
Vue.prototype.putRequest = putRequest
Vue.prototype.uploadFileRequest = uploadFileRequest
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js